import * as React from 'react';
import PropTypes from 'prop-types';

function SvgUserApprove52418601(props) {
  const { iconColor } = props;

  return (
    <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 125">
      <path
        d="M43 6a17 17 0 1017 17A17 17 0 0043 6zm0 4a13 13 0 11-13 13 13 13 0 0113-13zm0 34c-8.68 0-16.53 2.34-22.34 6.25S11 59.76 11 66v20a2 2 0 002 2h47.53a16 16 0 1013.94-25.91c-1.22-4.65-4.56-8.77-9.13-11.84C59.53 46.34 51.68 44 43 44zm0 4c7.94 0 15.09 2.21 20.12 5.59a17.63 17.63 0 017.19 8.66A16.1 16.1 0 0057 78a15.81 15.81 0 001.19 6H15V66c0-4.59 2.84-9 7.88-12.41S35.06 48 43 48zm30 18a12 12 0 11-12 12 12 12 0 0112-12zm6.81 6a2 2 0 00-1.4.75l-6.82 8.53-5.46-3.9a2 2 0 10-2.32 3.24l7 5a2 2 0 002.72-.37l8-10A2 2 0 0079.84 72z"
        fill={iconColor}
      />
    </svg>
  );
}
SvgUserApprove52418601.propTypes = {
  iconColor: PropTypes.string
};
SvgUserApprove52418601.defaultProps = {
  iconColor: undefined
};

export default SvgUserApprove52418601;
